<div class="flex items-center">
  <div class="title text-2xl leading-[0.7] capitalize text-premium">{{ 'label.full.credits' | transloco }}:&nbsp;</div>
</div>
